export default "__VITE_ASSET__$Bl0V2Gv__"